/**
 * Shared API / WebSocket base URLs.
 * Empty REACT_APP_API_URL means same-origin (Coolify nginx proxy).
 */
const rawApi = process.env.REACT_APP_API_URL;
export const API_URL =
  rawApi !== undefined ? rawApi : 'http://localhost:8888';

export function getWsBaseUrl(): string {
  if (process.env.REACT_APP_WS_URL) {
    return process.env.REACT_APP_WS_URL.replace(/\/ws$/, '');
  }
  if (API_URL) {
    return API_URL.replace(/^http/, 'ws');
  }
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}`;
}

/** Authenticated code-server proxy (Complic JWT cookie). */
export function getVscodeBaseUrl(): string {
  if (API_URL) {
    return `${API_URL.replace(/\/$/, '')}/vscode`;
  }
  return `${window.location.origin}/vscode`;
}

/**
 * Best-effort PM UI URL before /api/workspace/active responds.
 * On Coolify (complic.* → pm.*) avoids first paint loading localhost then remounting.
 */
export function getDefaultPmUiUrl(): string {
  if (typeof window === 'undefined') return 'http://localhost:3000';
  const host = window.location.hostname;
  if (host.startsWith('complic.')) {
    return `${window.location.protocol}//pm.${host.slice('complic.'.length)}/`;
  }
  if (host === 'localhost' || host === '127.0.0.1') {
    return 'http://localhost:3000';
  }
  return 'http://localhost:3000';
}

/** Reject localhost/127.0.0.1 preview URLs when Complic is served on a public host. */
export function resolvePmUiUrl(candidate?: string | null): string {
  const fallback = getDefaultPmUiUrl();
  const raw = (candidate || '').trim();
  if (!raw) return fallback;
  if (typeof window === 'undefined') return raw;
  const pageHost = window.location.hostname;
  if (pageHost === 'localhost' || pageHost === '127.0.0.1') return raw;
  try {
    const u = new URL(raw, window.location.origin);
    if (u.hostname === 'localhost' || u.hostname === '127.0.0.1') {
      return fallback;
    }
    return u.toString();
  } catch {
    return fallback;
  }
}

function normalizeUrl(u: string): string {
  try {
    const parsed = new URL(u);
    parsed.hash = '';
    let s = parsed.toString();
    if (s.endsWith('/') && parsed.pathname === '/') s = s.slice(0, -1) + '/';
    return s;
  } catch {
    return u.replace(/\/+$/, '') || u;
  }
}

/** True when iframe src should remount (host/path change), not for trailing-slash noise. */
export function pmUiUrlChanged(prev: string | null, next: string): boolean {
  if (!prev) return true;
  return normalizeUrl(prev) !== normalizeUrl(next);
}
